import { PostBoardingPassesIssueHpbpResponse } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { BoardingPassIssueHpbpModel } from './boarding-pass-issue-hpbp.state';

/** StateDetailsActions */
const ACTION_SET = '[BoardingPassIssueHpbp] set';
const ACTION_UPDATE = '[BoardingPassIssueHpbp] update';
const ACTION_RESET = '[BoardingPassIssueHpbp] reset';
const ACTION_FAIL = '[BoardingPassIssueHpbp] fail';
const ACTION_CANCEL_REQUEST = '[BoardingPassIssueHpbp] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[BoardingPassIssueHpbp] set from api';
const ACTION_UPDATE_FROM_API = '[BoardingPassIssueHpbp] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setBoardingPassIssueHpbp = createAction(ACTION_SET, props<WithRequestId<BoardingPassIssueHpbpModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateBoardingPassIssueHpbp = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<BoardingPassIssueHpbpModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetBoardingPassIssueHpbp = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelBoardingPassIssueHpbpRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failBoardingPassIssueHpbp = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setBoardingPassIssueHpbpFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostBoardingPassesIssueHpbpResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateBoardingPassIssueHpbpFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostBoardingPassesIssueHpbpResponse>>()
);
